export const macOS = {
  classes: {
    logoClass: "fa-brands fa-apple",
    wifiClass: "fa-solid fa-wifi",
    bateryClass: "fa-solid fa-battery-half",
    magnifyingGlassClass: "fa-solid fa-magnifying-glass",
  },
  siriIcon : require("../../assets/img/siri_dark.webp")
};
